import Skeleton from '@/components/common/LoadingSkeleton/Skeleton';

export const TopSkeleton = () => {
	return (
		<div className="w-full pt-16.5 pb-12.5 px-7.5 flex flex-col items-center gap-y-4">
			{/* Avatar và tên */}
			<Skeleton type="avatar" />

			{/* Stats */}
			<div className="w-full flex flex-col gap-y-2">
				<Skeleton lines={3} />
			</div>
			<Skeleton type="button" className="w-full" />
		</div>
	);
};
